export const Events = {
  USER_JOINED: 'user-joined',
  USER_LEFT: 'user-left',
  SET_ID: 'set-id',
  USER_ENTER_XR: 'user-enter-xr',
  USER_EXIT_XR: 'user-exit-xr',
  RADIO_TOGGLE: 'radio-toggle',
  PLAYER_SPEAK_CHANGE: 'player-speak-change',
  PLAYER_BROADCASTING_STREAM_OFFER: 'player-broadcasting-stream-offer',
  PLAYER_BROADCASTING_STREAM_ANSWER: 'player-broadcasting-stream-answer',
  PLAYER_SHARING_STREAM_OFFER: 'player-sharing-stream-offer',
  PLAYER_SHARING_STREAM_ANSWER: 'player-sharing-stream-answer',
  PLAYER_SHARING_STREAM_OFFER_ICE: 'player-sharing-stream-offer-ice',
  PLAYER_SHARING_STREAM_ANSWER_ICE: 'player-sharing-stream-answer-ice',
  PLAYER_STOPPED_SHARING_STREAM: 'player-stopped-sharing-stream',
  PLAYER_CLAIMING_MASTER_SHARE_ROLE: 'player-claiming-master-share-role',
  PLAYER_RELEASING_MASTER_SHARE_ROLE: 'player-releasing-master-share-role',
  PLAYER_SYNC_URL_VIDEO_START: 'player-sync-url-video-start',
  PLAYER_SYNC_URL_VIDEO_PING: 'player-sync-url-video-ping',
  PLAYER_REQUESTING_DEVICECONTROL_OFFER: 'player-requesting-devicecontrol-offer',
  PLAYER_REQUESTING_DEVICECONTROL_REJECTION: 'player-requesting-devicecontrol-rejection',
  PLAYER_REQUESTING_DEVICECONTROL_OFFER_ICE: 'player-requesting-devicecontrol-offer-ice',
  PLAYER_REQUESTING_DEVICECONTROL_ANSWER: 'player-requesting-devicecontrol-answer',
  PLAYER_REQUESTING_DEVICECONTROL_ANSWER_ICE: 'player-requesting-devicecontrol-answer-ice',
  PLAYER_PERMITTING_DEVICECONTROL_SUCCESS: 'player-permitting-devicecontrol-success',
  PLAYER_PERMITTING_DEVICECONTROL: 'player-permitting-devicecontrol',
  PLAYER_REVOKING_DEVICECONTROL_PERMISSION: 'player-revoking-devicecontrol-permission',
  PLAYER_REVOKING_DEVICECONTROL_PERMISSION_SUCCESS: 'player-revoking-devicecontrol-permission-success',
  PLAYER_REVOKING_DEVICECONTROL_PERMISSION_FAILURE: 'player-revoking-devicecontrol-permission-failure',
  OBJECT_GRAB: 'object-grab',
  OBJECT_TRANSFORM: 'object-transform',
  // EToy (dynamic toys) lifecycle
  TOY_CREATE_REQUEST: 'toy-create-request',
  TOY_CREATED: 'toy-created',
  TOY_SNAPSHOT: 'toy-snapshot',
  TOY_DELETE_ALL_REQUEST: 'toy-delete-all-request',
  TOY_ALL_DELETED: 'toy-all-deleted',
  SCENE_SWITCH_REQUEST: 'scene-switch-request',
  SCENE_SWITCH_RESPONSE: 'scene-switch-response',
  SCENE_SWITCH_APPROVED: 'scene-switch-approved',
  ORCHESTRATED_INFO_REQUEST: 'orchestrated-info-request',
  ORCHESTRATED_INFO_RESPONSE: 'orchestrated-info-response',
  ORCHESTRATED_SNAPSHOT: 'orchestrated-snapshot',
  AVATAR_SET_REQUEST: 'avatar-set-request',
  AVATAR_STATE_UPDATE: 'avatar-state-update',
  PROSTHETIC_SET_REQUEST: 'prosthetic-set-request',
  PROSTHETIC_STATE_UPDATE: 'prosthetic-state-update',
  MARKETPLACE_TIP_RECEIVED: 'marketplace-tip-received',
  SERVER_PING: 'server-ping',
  CLIENT_PONG: 'client-pong',
  // other events can be added here as needed
} as const;

export type EventName = typeof Events[keyof typeof Events];
